export function formatToMaxTwoDecimals(num: string | number): number {
	if (typeof num !== "number" || isNaN(num)) {
		return 0; // Return as is if not a valid number
	}

	// If the number has no decimals or only one decimal place, return it as is
	if (Math.floor(num) === num || (num * 10) % 1 === 0) {
		return num;
	}

	// Otherwise, return the number rounded to two decimal places
	return Math.round(num * 100) / 100;
}
